import { Controller } from "@hotwired/stimulus"
import { Modal, Offcanvas } from "bootstrap"

export default class extends Controller {
  static targets = ["menu", "toggle"]

  connect() {
    this.beforeCache = () => this.prepareForCache()
    document.addEventListener("turbo:before-cache", this.beforeCache)
    this.onShown = () => this.toggleTarget.setAttribute("aria-expanded", "true")
    this.onHidden = () => this.toggleTarget.setAttribute("aria-expanded", "false")
    this.menuTarget.addEventListener("shown.bs.offcanvas", this.onShown)
    this.menuTarget.addEventListener("hidden.bs.offcanvas", this.onHidden)
  }

  close() {
    Offcanvas.getInstance(this.menuTarget)?.hide()
  }

  prepareForCache() {
    const transitioning = ["show", "showing", "hiding"].some(name => this.menuTarget.classList.contains(name))
    if (!transitioning) return

    // Завершаем открытие до hide(), чтобы Bootstrap корректно освободил focus trap.
    if (this.menuTarget.classList.contains("showing")) {
      this.menuTarget.dispatchEvent(new Event("transitionend"))
    }
    this.close()
    // Turbo делает снимок раньше завершения CSS-перехода Bootstrap.
    // Завершаем переходы синхронно: в снимке не остаются подложка и scroll lock.
    document.querySelectorAll(".offcanvas-backdrop").forEach(element => element.dispatchEvent(new Event("transitionend")))
    this.menuTarget.dispatchEvent(new Event("transitionend"))
    this.toggleTarget.setAttribute("aria-expanded", "false")
  }

  call(event) {
    const trigger = event.currentTarget
    const openModal = () => {
      const element = document.querySelector("#contact-modal")
      element.addEventListener("hidden.bs.modal", () => {
        const focusTarget = trigger.offsetParent ? trigger : this.toggleTarget
        focusTarget.focus()
      }, { once: true })
      Modal.getOrCreateInstance(element).show(trigger)
    }
    const instance = Offcanvas.getInstance(this.menuTarget)
    const hideMenu = () => {
      this.menuTarget.addEventListener("hidden.bs.offcanvas", openModal, { once: true })
      instance.hide()
    }
    // Сначала освобождаем focus trap и блокировку прокрутки бокового меню.
    if (instance && this.menuTarget.classList.contains("showing")) {
      this.menuTarget.addEventListener("shown.bs.offcanvas", hideMenu, { once: true })
    } else if (instance && (this.menuTarget.classList.contains("show") || this.menuTarget.classList.contains("hiding"))) {
      hideMenu()
    } else {
      openModal()
    }
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.beforeCache)
    this.menuTarget.removeEventListener("shown.bs.offcanvas", this.onShown)
    this.menuTarget.removeEventListener("hidden.bs.offcanvas", this.onHidden)
    const instance = Offcanvas.getInstance(this.menuTarget)
    if (!instance) return
    if (this.menuTarget.classList.contains("show") || this.menuTarget.classList.contains("hiding")) {
      this.menuTarget.addEventListener("hidden.bs.offcanvas", () => instance.dispose(), { once: true })
      instance.hide()
    } else {
      instance.dispose()
    }
  }
}
